import { Button, Card, Stack, Typography, ValidationErrors } from "@compass/core";
import {
  Address,
  Parent,
  StudentParentEditResource,
  StudentParent as StudentParentModel,
  StudentParentViewResource,
} from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { StudentParent } from "./StudentParent";
import produce from "immer";

export const StudentParents = (props: {
  studentParents: StudentParentModel[];
  setStudentParents: (value: StudentParentModel[]) => void;
  validationErrors: ValidationErrors | string[];
  resetValidationErrors: () => void;
}) => {
  const [viewResource, setViewResource] = useState<StudentParentViewResource>({});
  const [editResource, setEditResource] = useState<StudentParentEditResource>({});

  useEffect(() => {
    fetchEditResource();
    fetchViewResource();
  }, []);

  const fetchEditResource = () => {
    ApiService.studentParents.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  const fetchViewResource = () => {
    ApiService.studentParents.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  const addStudentParent = () => {
    const newStudentParents = [...props.studentParents];
    newStudentParents.push({
      parent: {
        address: {} as Address,
      } as Parent,
    } as StudentParentModel);
    props.setStudentParents(newStudentParents);
  };

  return (
    <Stack spacing="md">
      {props.studentParents.length === 0 && (
        <Typography>You may add one or more parents here. Parents are optional.</Typography>
      )}

      <Stack spacing="md">
        {props.studentParents.map((studentParent, index) => {
          return (
            <StudentParent
              studentParent={studentParent}
              setStudentParent={(value: StudentParentModel) => {
                const newStudentParents = [...props.studentParents];
                newStudentParents[index] = value;
                props.setStudentParents(newStudentParents);
              }}
              viewResource={viewResource}
              editResource={editResource}
              validationErrors={props.validationErrors?.[index] || {}}
              cancelCreate={() => {
                props.setStudentParents(
                  produce(props.studentParents, (draft) => {
                    draft.splice(index, 1);
                  })
                );
                props.resetValidationErrors();
              }}
            />
          );
        })}
      </Stack>

      <Stack direction="row">
        <Button variant="outlined" onClick={addStudentParent}>
          + Add Parent
        </Button>
      </Stack>
    </Stack>
  );
};
